export default __webpack_public_path__ + "static/media/Snd2.4c93e561.mp3";